var ExpandMode = /** @class */ (function () {
    function ExpandMode() {
    }
    ExpandMode.None = 'None';
    ExpandMode.Selection = 'Selection';
    ExpandMode.All = 'All';
    return ExpandMode;
}());
export { ExpandMode };
function ExpandMode_tsickle_Closure_declarations() {
    /** @type {?} */
    ExpandMode.None;
    /** @type {?} */
    ExpandMode.Selection;
    /** @type {?} */
    ExpandMode.All;
}
//# sourceMappingURL=expand-mode.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/custom-tree-select/src/models/expand-mode.js
// module id = 16
// module chunks = 0